
import React from 'react';
import Button from '../base/Button';

const StickyActions: React.FC = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = '+971585375437';
    const message = encodeURIComponent('Hallo NextStep, ich interessiere mich für die Auswanderungsberatung in die V.A.E. und bitte um weitere Informationen. Mein Name ist: [Name]');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <div className="fixed bottom-4 right-4 z-40 md:hidden">
      <Button
        onClick={handleWhatsAppClick}
        className="shadow-xl"
        size="sm"
      >
        <i className="ri-whatsapp-line"></i>
      </Button>
    </div>
  );
};

export default StickyActions;
